import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import ReportingApiStore from '../../stores/ReportingApiStore';
import SnackStore from '../../stores/SnackStore';
import { ConsoleCard } from '../ConsoleFragments';
import { FTHeading, FTBody } from '../Fuse';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import FuseButton from '../FuseControls/FuseButton';
import FuseAlert from '../FuseControls/FuseAlert';
import FuseCheckbox from '../FuseControls/FuseCheckbox';
import FuseTextfield from '../FuseControls/FuseTextfield';

import './DeleteConfirmationModal.css';

const block = b.lock('DeleteConfirmationModal');

class DeleteConfirmationModal extends Component {
    static propTypes = {
        reportingApi: ReportingApiStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    onDeleteKey = () => {
        const { reportingApi } = this.props;
        const key = reportingApi.apiKey.value;
        reportingApi.delete().then(() => {
            this.props.snack.showSuccess(`Reporting API Key ${key} has been deleted.`);
            reportingApi.onCloseConfirmModal();
        });
    }

    render() {
        const { reportingApi } = this.props;
        return <FuseConsoleModal
            large
            isOpen={reportingApi.deleteConfirmationModal.isOpen}
            onClose={reportingApi.onCloseConfirmModal}
            greyBackground
            title="Delete Reporting API Key"
            headerActions={<FuseButton
                type={'primary'}
                color={'red'}
                loading={reportingApi.deleteStatus.isLoading}
                disabled={!reportingApi.confirmDelete.isTrue}
                onClick={this.onDeleteKey}
            >Delete</FuseButton>}
        >
            <FuseAlert
                title={'Delete Confirmation'}
                type="danger"
                className={block('Alert')}
            >
                <FTBody>
        Deleted API keys become deactivated and cannot be restored.
        Any requests to a deleted API key will result in a 403 error.
                </FTBody>
                <div className={block('ConfirmWrapper')}>
                    <FuseCheckbox
                        label={<FTBody
                            className={block('Label')}
                        >{'Confirm the deletion of this API Key'}</FTBody>}
                        store={reportingApi.confirmDelete}
                        className={block('ConfirmCheckbox')}
                        black
                    />

                </div>

            </FuseAlert>
            <ConsoleCard className={block('Summary')}>
                <FTHeading>Summary</FTHeading>
                <FuseTextfield
                    store={reportingApi.apiKey}
                    label="Reporting API Key"
                    leftIcon={'key'}
                    className={block('TextField')}
                    disabled
                />
            </ConsoleCard>
        </FuseConsoleModal>;
    }
}

export default inject('reportingApi', 'snack')(observer(DeleteConfirmationModal));
